import { createContext } from 'react'
import { GrundDialogData } from '../components/Befehle/GrundDialog'

interface GrundDialogContextType {
  openGrundDialog: (dialogData: GrundDialogData) => void
  submittedGruende: Record<string, string>
  resetGruende: (fieldName: string) => void
}

const GrundDialogContext = createContext<GrundDialogContextType>({
  openGrundDialog: () => {},
  submittedGruende: {},
  resetGruende: () => {}
})

export default GrundDialogContext
